import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appClickPreventPropagation]',
  standalone: true,
})
export class ClickPreventPropagationDirective {
  @HostListener('click', ['$event'])
  public onClick(event: any): void {
    event.stopPropagation();
  }
}
